import { UPDATE_FRIST_GELESEN } from '@/domain/navigation/benachrichtigungen/graphql/mutations';
import {
  Navigation_UpdateFristGelesenMutation,
  Navigation_UpdateFristGelesenMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateFristGelesen() {
  const [execute, result] = useMutation<
    Navigation_UpdateFristGelesenMutation,
    Navigation_UpdateFristGelesenMutationVariables
  >(UPDATE_FRIST_GELESEN, {
    refetchQueries: ['GetBenachrichtigungen'],
  });

  const updateFristGelesen = useCallback(
    (variables: Navigation_UpdateFristGelesenMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );
  return [updateFristGelesen, result] as const;
}
